/**
 * Avatar utilities for generating user avatars
 */

export const getAvatarUrl = (
  photoUrl: string | null | undefined,
  userId: string | null | undefined,
  userName: string | null | undefined,
  color: string = '0066cc'
): string => {
  // If valid photo URL exists, use it
  if (photoUrl && !photoUrl.startsWith('blob:') && photoUrl.startsWith('https://')) {
    return photoUrl;
  }

  // Generate avatar with initials
  const name = userName || userId || 'User';
  const initials = name
    .split(' ')
    .map((n: string) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2); // Limit to 2 characters

  // Remove # if color has it
  const cleanColor = color.replace('#', '');

  return `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=${cleanColor}&color=fff&size=128`;
};



